import { render, staticRenderFns } from "./TierReport.vue?vue&type=template&id=a36156d2&scoped=true"
import script from "./TierReport.vue?vue&type=script&lang=js"
export * from "./TierReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36156d2",
  null
  
)

export default component.exports